/* eslint-disable react/jsx-indent */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';

class CategoryItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const categoryChecked = this.props.selectedServices.filter((c) => c.id === this.props.service.id).length;

    return (
      <div className="service">
        <div>
          <input
            type="checkbox"
            className="checkbox-switch"
            id={`${this.props.service.name}${this.props.service.id ? this.props.service.id : 'category'}`}
            onChange={() => {
              this.props.onSelectService(this.props.service);
            }}
            checked={categoryChecked > 0}
          />
          <label
            htmlFor={`${this.props.service.name}${this.props.service.id ? this.props.service.id : 'category'}`}
            className="checkbox-bullet"
          >
            {this.props.service.name}
          </label>
        </div>
        {this.props.service.services &&
          this.props.service.services.length > 0 &&
          this.props.selectedServices.filter((c) => c.id === this.props.service.id).length > 0 && (
            <ul>
              {this.props.service.services.map((subService) => (
                <li key={subService.id} className="dropdown-item subItem">
                  <label className="clickable-label">
                    <span className="li-service">{subService.name}</span>
                    <div className="checkbox-box-custom-wrap dd-chk">
                      <input
                        type="checkbox"
                        className="checkbox-box-custom"
                        id={`clints-check-${subService.id ? subService.id : '1'}`}
                        checked={this.props.selectedServices.filter((c) => c.id === subService.id).length > 0}
                        onChange={() => {
                          this.props.onSelectService(subService);
                        }}
                      />
                      <label
                        className="checkbox-box-label"
                        htmlFor={`clints-check-${subService.id ? subService.id : '1'}`}
                      >
                        <div className="checkbox-box-custom-icon">
                          <span className="ic-sml-18px ic_check_white_18" />
                        </div>
                      </label>
                    </div>
                  </label>
                </li>
              ))}
            </ul>
          )}
      </div>
    );
  }
}

export default CategoryItem;
